/**
 * Dicionário pt-BR — fonte da verdade das chaves de tradução.
 * Interpolação: "{nome}" é substituído por vars.nome.
 */
export const ptBR = {
  common: {
    appName: "Tenanci",
    loading: "Carregando…",
    save: "Salvar",
    saving: "Salvando…",
    saved: "Salvo",
    cancel: "Cancelar",
    close: "Fechar",
    delete: "Excluir",
    deleting: "Excluindo…",
    edit: "Editar",
    create: "Criar",
    add: "Adicionar",
    back: "Voltar",
    next: "Continuar",
    retry: "Tentar novamente",
    copy: "Copiar",
    copied: "Copiado!",
    copyValue: "Copiar {label}",
    confirm: "Confirmar",
    enabled: "Ativo",
    disabled: "Inativo",
    optional: "opcional",
    actions: "Ações",
    moreActions: "Mais ações",
    learnMore: "Saiba mais",
    published: "Publicado",
    publishedDesc: "A alteração entra no ar em poucos segundos.",
    errorTitle: "Algo deu errado",
    moveUp: "Mover para cima",
    moveDown: "Mover para baixo",
    loadMore: "Carregar mais",
    never: "nunca",
    or: "ou",
    none: "—",
    theme: "Tema",
    themeLight: "Claro",
    themeDark: "Escuro",
    themeSystem: "Automático",
    language: "Idioma",
    languageCurrent: "Idioma: {lang}",
    skipToContent: "Pular para o conteúdo",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    typeToConfirm: "Digite {value} para confirmar",
    comingSoon: "Em breve",
  },
  nav: {
    main: "Navegação principal",
    home: "Início",
    projects: "Projetos",
    billing: "Plano e cobrança",
    apiKeys: "Chaves de API",
    account: "Minha conta",
    organization: "Organização",
    admin: "Administração",
    docs: "Ajuda e documentação",
    reportBug: "Reportar problema",
    signOut: "Sair",
  },
  admin: {
    title: "Administração da plataforma",
    subtitle: "Organizações (planos de cortesia e verificação de origem) e TenantGuard. Cada ação fica registrada na auditoria.",
    search: "Buscar por organização, e-mail do dono ou origem",
    searchButton: "Buscar",
    empty: "Nenhuma organização encontrada.",
    forbidden: "Esta área é restrita à administração da plataforma.",
    noSubscription: "Sem assinatura",
    comp: "cortesia",
    stripe: "Stripe",
    plan: "Plano",
    apply: "Dar plano de cortesia",
    removeComp: "Encerrar cortesia",
    planApplied: "Plano de cortesia aplicado",
    compRemoved: "Cortesia encerrada",
    stripeManaged: "Assinatura gerida pelo Stripe: altere pelo portal ou pelo Stripe.",
    projects: "Projetos",
    noProjects: "Nenhum projeto.",
    verified: "Origem verificada",
    verify: "Marcar origem como verificada",
    verifyTitle: "Verificar origem sem o TXT?",
    verifyDesc: "A origem {origin} passa a ser tratada como do cliente, sem a prova pelo DNS. Faça isso só quando tiver confirmado com o cliente.",
    projectVerified: "Origem marcada como verificada",
    domains: "{n} domínio(s)",
    failed: "Não foi possível concluir",
    tabs: { orgs: "Organizações", crowdsec: "TenantGuard", jobs: "Jobs", betaCodes: "Códigos beta" },
    suspended: "Suspensa",
    suspend: "Suspender",
    unsuspend: "Reativar",
    suspendTitle: "Suspender {org}?",
    suspendDesc: "Todos os domínios desta organização saem do ar (os visitantes veem a página de domínio suspenso). Use em caso de abuso, phishing ou fraude.",
    suspendReason: "Motivo (fica na auditoria)",
    suspendedOk: "Organização suspensa",
    unsuspendedOk: "Organização reativada",
    impersonate: "Acessar como cliente",
    impersonateHint: "Abre o painel desta organização. Tudo o que você fizer fica na atividade dela como Equipe Tenanci.",
    jobs: {
      desc: "Jobs que falharam de vez nos últimos 14 dias (DNS, certificado, publicação, webhooks…). Reenviar cria um job novo com os mesmos dados.",
      state: "Estado",
      states: { failed: "Falharam", retry: "Em nova tentativa", active: "Rodando" },
      empty: "Nenhum job neste estado.",
      queue: "Fila",
      when: "Quando",
      attempts: "Tentativas",
      error: "Erro",
      data: "Dados",
      retry: "Reenviar",
      retried: "Job reenviado",
    },
    beta: {
      desc: "Códigos que liberam o preço beta no checkout (um uso por código).",
      count: "Quantidade",
      prefix: "Prefixo",
      note: "Observação",
      create: "Gerar códigos",
      created: "{n} código(s) gerado(s)",
      empty: "Nenhum código ainda.",
      code: "Código",
      usedBy: "Usado por",
      unused: "Livre",
      active: "Ativo",
      inactive: "Desativado",
      disable: "Desativar",
      enable: "Ativar",
    },
    crowdsec: {
      notConfigured: "Gestão do TenantGuard desligada",
      notConfiguredDesc:
        "Defina a variável CROWDSEC_PANEL_PASSWORD (o mesmo valor) nos containers crowdsec-lapi, server e worker do tenanci-core e reinicie. O LAPI registra a máquina do painel sozinho.",
      tabs: { overview: "Visão geral", decisions: "Banimentos", alerts: "Alertas", allowlist: "IPs liberados" },
      lapi: "LAPI",
      online: "No ar",
      offline: "Fora do ar",
      unknown: "Sem dados",
      last24h: "Últimas 24 horas",
      alerts: "Alertas",
      waf: "Bloqueios do WAF",
      bans: "Banimentos",
      uniqueIps: "IPs diferentes",
      activeBans: "Banimentos ativos",
      manualBans: "{n} manuais",
      noAnalytics: "Histórico indisponível: o analytics (ClickHouse) não respondeu.",
      timeline: "Alertas por hora",
      seriesAlerts: "Alertas",
      seriesBans: "Banimentos",
      topScenarios: "Ataques mais comuns",
      topDomains: "Domínios mais atacados",
      topIps: "IPs mais ativos",
      components: "Componentes",
      machines: "Agentes (máquinas)",
      bouncers: "Bouncers",
      edges: "Nós do edge",
      lastSeen: "Último contato",
      version: "Versão",
      never: "nunca",
      unreadable: "Não foi possível ler o banco do LAPI.",
      search: "Buscar por IP, motivo ou domínio",
      ban: "Banir IP",
      banTitle: "Banir um IP ou faixa",
      banDesc: "O banimento vale em todos os edges em até 10 segundos.",
      ipLabel: "IP ou faixa (CIDR)",
      ipHint: "Ex.: 203.0.113.7 ou 203.0.113.0/24 (no mínimo /16).",
      duration: "Duração",
      durations: { "1h": "1 hora", "4h": "4 horas", "24h": "24 horas", "7d": "7 dias", "30d": "30 dias", "365d": "1 ano", "1d": "1 dia", "90d": "90 dias", never: "Sem validade" },
      reason: "Motivo",
      reasonPlaceholder: "Ex.: varredura no checkout",
      banned: "IP banido",
      unban: "Desbanir",
      unbanTitle: "Desbanir {ip}?",
      unbanDesc: "O IP volta a acessar todos os domínios. Se continuar atacando, o TenantGuard pode banir de novo.",
      unbanned: "Banimento removido",
      noDecisions: "Nenhum banimento ativo.",
      ip: "IP",
      motive: "Motivo",
      origin: "Origem",
      originAuto: "Automático",
      originManual: "Manual",
      domains: "Domínios",
      created: "Início",
      expires: "Expira",
      actions: "Ações",
      showing: "{shown} de {total}",
      period: "Período",
      periods: { "24": "24 horas", "168": "7 dias", "720": "30 dias", "2160": "90 dias" },
      kind: "Tipo",
      kinds: { all: "Todos", waf: "WAF", scenario: "Comportamento", manual: "Manual" },
      filterIp: "IP",
      filterHost: "Domínio",
      filter: "Filtrar",
      clear: "Limpar",
      noAlerts: "Nenhum alerta com esses filtros.",
      when: "Quando",
      attack: "Ataque",
      request: "Requisição",
      result: "Resultado",
      resultBan: "IP banido",
      resultWaf: "Bloqueada",
      resultAlert: "Detectado",
      details: "Detalhes",
      userAgent: "User-Agent",
      network: "Rede",
      events: "Eventos",
      machine: "Agente",
      message: "Mensagem",
      allow: "Liberar IP",
      allowTitle: "Liberar um IP ou faixa",
      allowDesc:
        "IPs liberados nunca são banidos e o WAF não inspeciona as requisições deles. Use para o escritório, monitoramento ou integrações do cliente. Vale em todos os edges em até 1 minuto.",
      comment: "Comentário",
      commentPlaceholder: "Ex.: escritório do cliente Bree",
      validity: "Validade",
      allowed: "IP liberado",
      allowedUnbanned: "IP liberado e {n} banimento(s) removido(s)",
      unallow: "Remover",
      unallowTitle: "Remover {ip} da lista?",
      unallowDesc: "O IP volta a passar pelo WAF e pode ser banido pelo TenantGuard.",
      unallowed: "IP removido da lista",
      noAllowlist: "Nenhum IP liberado.",
      expiresNever: "Sem validade",
      createdBy: "Liberado por",
      refresh: "Atualizar",
    },
  },
  errors: {
    unauthorized: "Sua sessão expirou. Entre novamente.",
    forbidden: "Você não tem permissão para fazer isso.",
    not_found: "Não encontramos o que você procurava. Talvez tenha sido excluído.",
    subscription_required: "Sua assinatura não está ativa. Escolha um plano para continuar.",
    feature_not_in_plan: "Este recurso não está incluído no seu plano. Faça upgrade para usar.",
    domain_limit_reached: "Você atingiu o limite de domínios do plano. Aceite a cobrança de domínio extra ou mude de plano.",
    hostname_taken: "Este domínio já está em uso em outra conta da Tenanci. Fale com o suporte para transferi-lo.",
    domain_exists: "Este domínio já está cadastrado na sua conta.",
    invalid_hostname: "Domínio inválido. Use algo como app.seucliente.com.br.",
    invalid_origin: "URL de origem inválida. Use um endereço público, como https://app.seusaas.com.",
    invalid_extra_origin: "Uma das origens extras é inválida.",
    invalid_route: "Rota inválida: origem e destino devem ser caminhos começando com /.",
    invalid_header: "Header inválido. O nome só pode ter letras, números e - _ .",
    invalid_injection: "Conteúdo HTML inválido ou grande demais.",
    invalid_ip: "IP inválido. Use um IP (203.0.113.7) ou uma faixa CIDR (203.0.113.0/24).",
    range_too_wide: "Faixa larga demais: o mínimo é /16 (IPv4) ou /32 (IPv6).",
    allowlisted: "Este IP está na lista de liberados: remova-o de lá antes de banir.",
    already_allowlisted: "Este IP já está na lista de liberados.",
    crowdsec_unavailable: "O TenantGuard (LAPI) não respondeu. Tente de novo em instantes.",
    crowdsec_not_configured: "A gestão do TenantGuard não está configurada (CROWDSEC_PANEL_PASSWORD).",
    analytics_unavailable: "O histórico (analytics) está indisponível no momento.",
    invalid_path: "O padrão de caminho deve começar com /.",
    invalid_seo: "Dados de SEO inválidos (confira a URL da imagem).",
    invalid_rules: "As regras do TailorKit estão em um formato inválido.",
    rules_too_large: "As regras do TailorKit passaram de 512 KB. Remova algumas alterações.",
    no_draft: "Não há rascunho para publicar. Salve antes.",
    no_subscription: "Você ainda não tem assinatura. Faça a contratação primeiro.",
    already_subscribed: "Sua organização já tem uma assinatura ativa. Use a troca de plano.",
    invalid_beta_code: "Código beta inválido ou já utilizado.",
    billing_unavailable: "A cobrança está indisponível no momento. Tente novamente em alguns minutos.",
    plan_not_configured: "Este plano ainda não está disponível para contratação.",
    storage_unavailable: "O envio de arquivos não está disponível. Use uma URL.",
    missing_file: "Selecione um arquivo.",
    invalid_size: "Arquivo vazio ou maior que 1 MB.",
    invalid_type: "Formato não suportado. Envie PNG, ICO, SVG, WEBP, JPG ou GIF.",
    unsafe_svg: "SVG com script não é permitido.",
    validation_error: "Alguns dados estão inválidos. Confira os campos.",
    invalid_json: "Requisição inválida.",
    idempotency_key_reused: "Esta operação já foi enviada com outros dados. Recarregue a página.",
    rate_limited: "Muitas tentativas em pouco tempo. Aguarde um instante.",
    internal_error: "Erro interno do servidor. Já fomos avisados — tente de novo em instantes.",
    network: "Sem conexão com o servidor. Verifique sua internet.",
    unknown: "Algo deu errado. Tente novamente.",
  },
  authErrors: {
    INVALID_EMAIL_OR_PASSWORD: "E-mail ou senha incorretos.",
    EMAIL_NOT_VERIFIED: "Confirme seu e-mail antes de entrar.",
    USER_ALREADY_EXISTS: "Já existe uma conta com este e-mail.",
    USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "Já existe uma conta com este e-mail.",
    PASSWORD_TOO_SHORT: "A senha precisa ter pelo menos 10 caracteres.",
    PASSWORD_TOO_LONG: "A senha é longa demais.",
    INVALID_PASSWORD: "Senha atual incorreta.",
    INVALID_EMAIL: "E-mail inválido.",
    INVALID_TOKEN: "O link expirou ou é inválido. Peça um novo.",
    TOKEN_EXPIRED: "O link expirou. Peça um novo.",
    CHANGE_EMAIL_DISABLED: "A troca de e-mail ainda não está disponível. Fale com o suporte.",
    SESSION_EXPIRED: "Por segurança, entre novamente para fazer esta alteração.",
    CREDENTIAL_ACCOUNT_NOT_FOUND: "Sua conta ainda não tem senha. Use “Esqueci minha senha” para criar uma.",
    USER_NOT_FOUND: "Não encontramos uma conta com este e-mail.",
    INVALID_ORIGIN: "Origem não autorizada. Recarregue a página.",
  },
  hostname: {
    empty: "Informe o domínio.",
    invalid_format: "Formato inválido. Use algo como app.seucliente.com.br.",
    ip_not_allowed: "Use um nome de domínio, não um endereço IP.",
    not_public_suffix: "Este não parece um domínio público válido.",
    reserved: "Domínios da Tenanci não podem ser cadastrados.",
    too_long: "Domínio longo demais.",
    apex: "Domínio raiz (apex): configure com registro A.",
    subdomain: "Subdomínio de {base}: configure com registro CNAME.",
    willSaveAs: "Vamos cadastrar como {hostname}.",
    wwwHint: "Dica: www.{host} e {host} são domínios diferentes. Cadastre os dois se precisar.",
  },
  validation: {
    required: "Campo obrigatório.",
    email: "Informe um e-mail válido.",
    passwordMin: "A senha precisa ter pelo menos 10 caracteres.",
    passwordMismatch: "As senhas não conferem.",
    path: "Use um caminho começando com /, ex.: /precos.",
    url: "Informe uma URL completa, começando com https://.",
    headerName: "Use apenas letras, números e - _ .",
    json: "JSON inválido.",
  },
  auth: {
    tagline: "Seu app no domínio dos seus clientes.",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    login: {
      title: "Entrar na Tenanci",
      subtitle: "Bem-vindo de volta!",
      submit: "Entrar",
      submitting: "Entrando…",
      forgot: "Esqueci minha senha",
      magicLink: "Receber link de acesso por e-mail",
      magicLinkSubmit: "Enviar link de acesso",
      usePassword: "Entrar com senha",
      magicSentTitle: "Link enviado!",
      magicSentDesc: "Se houver uma conta para {email}, você vai receber um link de acesso válido por 15 minutos.",
      noAccount: "Ainda não tem conta?",
      signupLink: "Criar conta",
      notVerified: "Seu e-mail ainda não foi confirmado.",
      resend: "Reenviar e-mail de confirmação",
      resent: "Enviamos um novo link de confirmação.",
      migratedHint: "Veio do painel antigo? Use “Receber link de acesso” no primeiro acesso.",
    },
    signup: {
      title: "Crie sua conta",
      subtitle: "Leva menos de um minuto.",
      passwordHint: "Mínimo de 10 caracteres.",
      submit: "Criar conta",
      submitting: "Criando…",
      hasAccount: "Já tem conta?",
      loginLink: "Entrar",
      terms: "Ao criar a conta você concorda com os Termos de uso e a Política de privacidade da Tenanci.",
    },
    verifyEmail: {
      title: "Confira seu e-mail",
      desc: "Enviamos um link de confirmação para {email}. Clique nele para ativar sua conta.",
      descNoEmail: "Enviamos um link de confirmação para o seu e-mail. Clique nele para ativar sua conta.",
      tip: "Não chegou em alguns minutos? Veja a caixa de spam ou reenvie.",
      resend: "Reenviar e-mail",
      resent: "Pronto! Enviamos outro link.",
      backToLogin: "Voltar para o login",
    },
    forgot: {
      title: "Esqueceu a senha?",
      desc: "Informe seu e-mail e enviaremos um link para definir uma nova senha.",
      submit: "Enviar link",
      sentTitle: "Verifique seu e-mail",
      sentDesc: "Se houver uma conta para {email}, você vai receber o link em instantes.",
    },
    reset: {
      title: "Definir nova senha",
      newPassword: "Nova senha",
      confirmPassword: "Confirme a nova senha",
      submit: "Salvar nova senha",
      success: "Senha alterada! Faça login com a nova senha.",
      invalidToken: "Este link expirou ou já foi usado.",
      requestNew: "Pedir um novo link",
    },
    callback: {
      signingIn: "Entrando…",
      errorTitle: "Não foi possível entrar",
      errorDesc: "O link expirou ou já foi usado. Peça um novo.",
      backToLogin: "Voltar para o login",
    },
  },
  onboarding: {
    title: "Vamos configurar sua conta",
    stepOf: "Etapa {current} de {total}",
    steps: {
      profile: "Perfil",
      plan: "Plano",
      project: "Primeiro projeto",
    },
    profileTitle: "Como você vai usar a Tenanci?",
    profiles: {
      saas_owner: { title: "Dono de SaaS", desc: "Quero oferecer meu app no domínio dos meus clientes." },
      agency: { title: "Agência", desc: "Crio e gerencio apps para vários clientes." },
      reseller: { title: "Revendedor", desc: "Revendo soluções white-label com a minha marca." },
    },
    referralTitle: "Como nos encontrou?",
    referrals: {
      comunidade_semcodar: "Comunidade SemCodar",
      construindo_startup: "Construindo uma Startup",
      saas_7d: "SaaS 7D - Fundadores",
      indicacao: "Indicação de um amigo",
      google_ads: "Anúncios do Google",
      instagram_ads: "Anúncios do Instagram",
      facebook_ads: "Anúncios do Facebook",
      outro: "Outro",
    },
    referralOther: "Conte rapidinho",
    orgName: "Nome da sua empresa",
    orgNameHint: "Aparece nas faturas e no painel.",
    pickProfile: "Escolha uma opção.",
    saveFailed: "Não conseguimos salvar suas respostas agora, mas você pode seguir — dá para editar depois em Organização.",
    planTitle: "Escolha seu plano",
    planDesc: "Você pode trocar de plano quando quiser, sem perder nada.",
    cardNoticeTitle: "Por que pedimos cartão até no plano grátis?",
    cardNotice:
      "Todos os planos exigem um cartão, inclusive o Starter gratuito. No Starter você não paga nada: o cartão só confirma que você é uma pessoa real e protege a plataforma (e seus clientes) contra abuso e phishing. Domínios extras só são cobrados quando você adicioná-los, e o painel sempre mostra o valor antes.",
    continueToStripe: "Continuar para o pagamento seguro",
    redirecting: "Abrindo o Stripe…",
    stripeNote: "Pagamento processado pelo Stripe. A Tenanci não armazena os dados do seu cartão.",
    betaCode: "Código beta",
    betaCodeToggle: "Tenho um código beta",
    waitingActivation: "Confirmando sua assinatura… isso leva só alguns segundos.",
    projectTitle: "Crie seu primeiro projeto",
    projectDesc: "Um projeto é o app que você quer servir com domínios white-label (ex.: seu SaaS no Bubble ou FlutterFlow).",
    finish: "Criar projeto",
    skip: "Fazer isso depois",
    doneTitle: "Tudo pronto!",
  },
  gate: {
    inactiveBanner: "Sua assinatura não está ativa. Escolha um plano para liberar o painel.",
    pastDueBanner: "Pagamento pendente. Atualize o cartão no portal de pagamento para evitar a suspensão dos domínios.",
    seePlans: "Ver planos",
    openPortal: "Atualizar pagamento",
  },
  billing: {
    compNote: "Plano de cortesia concedido pela Tenanci: sem cobrança e sem cartão. Para mudar, fale com o suporte.",
    compPlansNote: "Sua organização está num plano de cortesia. A troca de plano é feita pelo suporte da Tenanci.",
    title: "Plano e cobrança",
    subtitle: "Seu plano, uso de domínios, cartão e faturas.",
    currentPlan: "Plano atual",
    noPlan: "Você ainda não tem um plano ativo",
    noPlanDesc: "Escolha um plano abaixo para liberar o painel.",
    usage: "Domínios em uso",
    usageOf: "{used} de {capacity}",
    packs: "{included} inclusos + {n} pacote(s) de {size}: {price}/mês",
    autoPacks: "Comprar o próximo pacote sozinho quando a API ou um agente de IA passar do limite (aviso por e-mail; no painel sempre perguntamos)",
    autoPacksSaved: "Preferência salva",
    renewsOn: "Renova em {date}",
    cancelsOn: "Será cancelado em {date}",
    manage: "Gerenciar pagamento e faturas",
    manageDesc: "Trocar cartão, baixar faturas e cancelar ficam no portal seguro do Stripe.",
    opening: "Abrindo…",
    plans: "Planos",
    currentBadge: "Seu plano",
    choose: "Assinar {plan}",
    changeTo: "Mudar para {plan}",
    perMonth: "/mês",
    free: "Grátis",
    includedDomains: "{n} domínios inclusos",
    extraPack: "+{size} domínios por {price}/mês (pacote extra)",
    noExtra: "Sem domínios extras: para mais, mude de plano",
    runningTests: "Até {n} testes A/B de landing pages rodando",
    unavailable: "Em breve",
    status: {
      incomplete: "Pagamento incompleto",
      trialing: "Em teste",
      active: "Ativa",
      past_due: "Pagamento atrasado",
      unpaid: "Não paga",
      canceled: "Cancelada",
    },
    checkoutSuccess: "Pagamento confirmado! Estamos ativando sua assinatura…",
    checkoutActivated: "Assinatura ativa. Tudo pronto!",
    checkoutSlow: "Ainda estamos aguardando a confirmação do Stripe. Pode levar um minuto — recarregue em instantes.",
    checkoutCanceled: "Pagamento cancelado. Nenhuma cobrança foi feita.",
    changeTitle: "Mudar para o plano {plan}?",
    changeDesc: "A diferença de preço é calculada proporcionalmente (proração) e aparece na próxima fatura. O cartão cadastrado é usado automaticamente.",
    changeOverQuota: "Atenção: você usa {used} domínios e o plano {plan} inclui {included}. Os excedentes entram em pacotes de {size} domínios ({price}/mês cada).",
    changeBlocked: "O plano {plan} comporta {included} domínios e você usa {used}. Remova domínios antes de trocar.",
    changed: "Plano alterado! Pode levar alguns segundos para atualizar aqui.",
    preview: {
      loading: "Calculando o valor…",
      monthly: "Nova mensalidade: {amount}/mês",
      dueNow: "Cobrança proporcional hoje: {amount}",
      packs: "inclui {n} pacote(s) de {size} domínios (até {capacity})",
      unavailable: "Não foi possível calcular o valor agora.",
    },
    cardRequired: "Cartão obrigatório em todos os planos, inclusive no Starter (sem cobrança).",
    features: {
      starter: ["TenantGuard (WAF + IDPS)", "Analytics básico", "Personalização de requests"],
      landing: ["Tudo do Starter", "Testes A/B de landing pages (com tráfego automático)", "Analytics avançado, metas e funis", "Conversões pelo servidor (Meta, Google, TikTok)"],
      growth: ["Tudo do Landing", "TailorKit (editor visual)", "SEO avançado", "Portal do cliente, app instalável e e-mail com a marca"],
      scale: ["Tudo do Growth", "AuthMesh", "API Gateway"],
    },
  },
  home: {
    greeting: "Olá, {name}!",
    subtitle: "Um resumo rápido da sua conta.",
    projects: "Seus projetos",
    seeAll: "Ver todos",
    newProject: "Novo projeto",
    noProjects: "Você ainda não tem projetos. Crie o primeiro para começar.",
    usage: "Uso de domínios",
    plan: "Plano",
    docs: "API e integrações",
    docsDesc: "Automatize domínios a partir do seu app com a API da Tenanci.",
    news: "Novidades",
    newsItems: [
      "Painel novo: as personalizações são publicadas na hora — acabou o “Salvar alterações”.",
      "Status do domínio ao vivo, com histórico de cada etapa (DNS, certificado, ativo).",
      "SEO por domínio e por página, com pré-visualização do card social.",
    ],
  },
  projects: {
    title: "Projetos",
    subtitle: "Cada projeto é um app de origem servido em vários domínios white-label.",
    new: "Novo projeto",
    emptyTitle: "Nenhum projeto ainda",
    emptyDesc: "Crie um projeto com a URL do seu app para começar a adicionar domínios.",
    domainsCount: "{n} domínio(s)",
    name: "Nome do projeto",
    namePlaceholder: "Ex.: CRM da Craft",
    origin: "URL de origem",
    originPlaceholder: "https://app.seusaas.com",
    originHint: "O endereço onde seu app já roda hoje.",
    create: "Criar projeto",
    creating: "Criando…",
    created: "Projeto criado! Agora confirme que a origem é sua.",
    status: {
      pending_verification: "Aguardando verificação",
      active: "Ativo",
      disabled: "Desativado",
    },
    tabs: {
      overview: "Visão geral",
      domains: "Domínios",
      customization: "Personalização",
      status: "Status",
      integration: "Integração",
      portal: "Portal do cliente",
      apis: "APIs",
    },
    deleteTitle: "Excluir projeto",
    deleteDesc: "Isso remove o projeto e todos os domínios dele do ar. Não dá para desfazer.",
    deleteAction: "Excluir projeto",
    deleted: "Projeto excluído.",
    dangerZone: "Zona de perigo",
  },
  ownership: {
    title: "Verificação de propriedade",
    desc: "Para evitar uso indevido (ex.: phishing), confirme que a origem é sua criando este registro TXT no DNS de {domain}. Nenhum domínio entra no ar antes disso.",
    verified: "Origem verificada",
    verifiedAt: "Verificada em {date}",
    pending: "Pendente",
    type: "Tipo",
    name: "Nome / Host",
    value: "Valor",
    verifyNow: "Verificar agora",
    checking: "Verificando…",
    success: "Tudo certo! Propriedade verificada.",
    notFound: "Ainda não encontramos o registro. A propagação do DNS pode levar alguns minutos.",
    foundValues: "Valores TXT encontrados em {name}:",
    noneFound: "Nenhum registro TXT encontrado em {name}.",
    providerHint: "Alguns provedores (Registro.br, GoDaddy, Hostinger) completam o domínio sozinhos. Nesse caso, use só {short} no campo nome.",
  },
  overview: {
    origin: "Origem",
    originDesc: "O app que é servido nos domínios deste projeto.",
    originChangeWarning: "Trocar para outro domínio exige uma nova verificação de propriedade.",
    general: "Dados do projeto",
    saved: "Configurações salvas",
    ids: "Identificadores",
    projectId: "ID do projeto",
    legacyId: "ID legado (Bubble)",
    tailorkitHost: "Host do TailorKit",
    spa: {
      title: "App de página única (SPA)",
      desc: "Para apps Flutter, React ou Vue que navegam sem recarregar a página.",
      mode: "Modo de navegação",
      mask: "Mascarar",
      maskDesc: "O visitante sempre vê o domínio do seu cliente na barra de endereço.",
      redirect: "Redirecionar",
      redirectDesc: "Rotas são redirecionadas (302). Use se o app tiver problemas com o modo mascarado.",
      initialRouteVar: "Enviar rota inicial em variável",
      initialRouteVarDesc: "Útil para Flutter Web: a rota acessada é repassada ao app na inicialização.",
    },
    extraOrigins: {
      title: "Origens extras",
      desc: "Hosts adicionais que seu app carrega (CDN, API, storage) e que devem passar pelo proxy.",
      placeholder: "cdn.seusaas.com",
      add: "Adicionar origem",
      empty: "Nenhuma origem extra.",
      remove: "Remover {host}",
      invalid: "Host inválido",
      duplicate: "Esse host já está na lista",
    },
  },
  domains: {
    title: "Domínios",
    subtitle: "Domínios white-label que servem este projeto.",
    add: "Adicionar domínio",
    emptyTitle: "Nenhum domínio ainda",
    emptyDesc: "Adicione o domínio do seu cliente. Mostramos exatamente qual registro DNS criar.",
    col: {
      name: "Nome",
      hostname: "Domínio",
      status: "Status",
      created: "Criado em",
    },
    menu: {
      open: "Ver detalhes",
      edit: "Editar",
      disable: "Desativar",
      enable: "Ativar",
      recheck: "Verificar DNS de novo",
      tailorkit: "Abrir TailorKit",
      delete: "Excluir",
    },
    disabledToast: "Domínio desativado.",
    enabledToast: "Domínio reativado.",
    recheckToast: "Nova verificação de DNS iniciada.",
    deleteTitle: "Excluir domínio",
    deleteDesc: "{hostname} sai do ar e o certificado é revogado. Não dá para desfazer.",
    deleted: "Domínio excluído.",
    editTitle: "Editar domínio",
    status: {
      pending_dns: "Aguardando DNS",
      verifying: "Verificando",
      issuing_cert: "Emitindo certificado",
      active: "Ativo",
      suspended: "Suspenso",
      error: "Erro",
      removed: "Removido",
      unknown: "Desconhecido",
    },
    statusDesc: {
      pending_dns: "Configure o registro DNS abaixo. Verificamos automaticamente.",
      verifying: "Confirmando a propriedade do domínio.",
      issuing_cert: "DNS encontrado! Emitindo o certificado HTTPS (geralmente 1 a 2 minutos).",
      active: "No ar, com HTTPS.",
      suspended: "Fora do ar temporariamente.",
      error: "Algo impediu a ativação. Veja o motivo e tente de novo.",
      removed: "Domínio removido.",
      unknown: "",
    },
    reasons: {
      created: "Domínio cadastrado",
      dns_ok: "Registro DNS encontrado",
      dns_timeout: "Não encontramos o registro DNS em 7 dias",
      cert_issued: "Certificado HTTPS emitido",
      cert_timeout: "Tempo esgotado ao emitir o certificado",
      cert_failed: "Falha ao emitir o certificado",
      user_disabled: "Desativado por você",
      user_enabled: "Reativado por você",
      recheck_requested: "Nova verificação solicitada",
      deleted: "Excluído",
      billing: "Assinatura inativa",
      tailorkit_viewer: "Host do editor TailorKit",
    },
    addTitle: "Adicionar domínio",
    addDesc: "Use o domínio (ou subdomínio) do seu cliente. Depois mostramos o registro DNS a criar.",
    hostname: "Domínio",
    hostnamePlaceholder: "app.seucliente.com.br",
    displayName: "Nome de exibição",
    displayNamePlaceholder: "Ex.: Cliente Silence",
    quotaOk: "Você usa {used} de {capacity} domínios do seu plano.",
    quotaExtra: "Você já usa {used} de {capacity} domínios. Para este domínio entra um pacote de {size} domínios: {price}/mês.",
    quotaUpgrade: "Você já usa {used} de {capacity} domínios, o limite do seu plano. Para adicionar mais, mude de plano.",
    seePlans: "Ver planos",
    acceptExtra: "Concordo com o pacote de {size} domínios por {price}/mês.",
    acceptRequired: "Confirme o pacote de domínios para continuar.",
    ownConfig: "Usar configuração própria (não herdar as personalizações do projeto)",
    submit: "Adicionar domínio",
    submitting: "Adicionando…",
    created: "Domínio adicionado! Agora configure o DNS.",
    verifyProjectFirst: "A origem do projeto ainda não foi verificada. Você já pode adicionar domínios, mas eles só entram no ar depois da verificação.",
  },
  domain: {
    back: "Domínios",
    dnsTitle: "Configuração de DNS",
    dnsDesc: "Crie este registro no provedor de DNS do domínio (Registro.br, Cloudflare, GoDaddy…).",
    dnsApexMulti: "Crie um registro A para cada IP abaixo.",
    type: "Tipo",
    name: "Nome",
    value: "Valor",
    ttl: "TTL: automático (ou 300 segundos).",
    cloudflareHint: "Usa Cloudflare? Deixe a nuvem cinza (“DNS only”), sem proxy.",
    lastCheck: "Última verificação: {date}",
    timelineTitle: "Linha do tempo",
    live: "Atualizando ao vivo",
    noEvents: "Nenhum evento ainda.",
    recheck: "Verificar de novo",
    openTailorkit: "Abrir TailorKit",
    experiments: "Testes A/B",
    tabs: {
      setup: "Configuração",
      settings: "Ajustes",
      customization: "Personalização",
      seo: "SEO",
      marketing: "Marketing",
      app: "App instalável",
      access: "Acesso",
    },
    settings: {
      title: "Ajustes do domínio",
      name: "Nome de exibição",
      saved: "Ajustes salvos",
    },
    waf: {
      title: "TenantGuard (WAF)",
      desc: "Firewall de aplicação que protege o domínio contra ataques comuns.",
      mode: "Modo",
      off: "Desligado",
      monitor: "Monitorar (só registra)",
      block: "Bloquear ataques",
      failMode: "Se o WAF ficar indisponível",
      open: "Deixar passar (prioriza disponibilidade)",
      closed: "Bloquear (prioriza segurança)",
    },
    performance: {
      title: "Desempenho",
      desc: "Arquivos JS e CSS do app que não mudam ficam guardados no edge, já comprimidos no nível máximo.",
      direct: "Arquivos estáticos direto da origem",
      directHint:
        "Economiza tráfego: os navegadores baixam direto do servidor do app os JS/CSS, fontes e imagens que não mudam (só os que não precisam de ajuste). O endereço original do app aparece nas requisições desses arquivos; desligue se o cliente não puder ver.",
      htmlCache: "Cache do HTML",
      htmlCacheHint:
        "Para sites em que a página é igual para todos os visitantes (apps de uma página só: React, Vue, Lovable…). O edge guarda o HTML e responde na hora, mesmo quando o servidor do app está lento; atualiza em segundo plano. Não use em apps Bubble nem em sites que montam a página com dados do usuário logado.",
      htmlCacheOff: "Desligado",
      htmlCache60: "1 minuto",
      htmlCache300: "5 minutos",
      htmlCache3600: "1 hora",
    },
    favicon: {
      title: "Favicon",
      desc: "Ícone exibido na aba do navegador para este domínio.",
      url: "URL do favicon",
      upload: "Enviar arquivo",
      uploading: "Enviando…",
      uploadHint: "PNG, ICO, SVG, WEBP, JPG ou GIF, até 1 MB.",
      remove: "Remover favicon",
      saved: "Favicon atualizado",
      removed: "Favicon removido",
      unknownCurrent: "O favicon atual não é exibido aqui ainda.",
    },
    overrides: {
      title: "Herança de configuração",
      desc: "Por padrão este domínio usa as personalizações do projeto. Ative uma seção para usar regras só deste domínio.",
      inherit: "Herdando do projeto",
      own: "Configuração própria",
      toggle: "Usar configuração própria em {section}",
      inheritedRules: "Regras herdadas do projeto (somente leitura):",
      editInProject: "Editar no projeto",
      switched: "Herança atualizada",
    },
    dangerZone: "Zona de perigo",
    deleteDesc: "Remove o domínio do ar e revoga o certificado.",
  },
  sections: {
    routes: "Rotas",
    headers: "Headers",
    injections: "Injeção de HTML",
  },
  rules: {
    toggle: "Ativar ou desativar regra",
    deleteConfirm: "Excluir esta regra?",
    deleted: "Regra excluída",
    empty: "Nenhuma regra ainda.",
    routes: {
      desc: "Mapeie caminhos amigáveis do domínio para caminhos da origem.",
      source: "Caminho no domínio",
      sourcePlaceholder: "/precos",
      destination: "Caminho na origem",
      destinationPlaceholder: "/pricing",
      mode: "Modo",
      rewrite: "Reescrever (URL mascarada)",
      redirect: "Redirecionar (302)",
      add: "Adicionar rota",
    },
    headers: {
      desc: "Headers HTTP adicionados às respostas (para o navegador) ou às requisições (para a origem).",
      name: "Nome",
      namePlaceholder: "X-Frame-Options",
      value: "Valor",
      valuePlaceholder: "SAMEORIGIN",
      direction: "Direção",
      response: "Resposta (navegador)",
      request: "Requisição (origem)",
      add: "Adicionar header",
    },
    injections: {
      desc: "Scripts e tags (analytics, chat, pixels) inseridos em todas as páginas.",
      position: "Onde inserir",
      head: "No <head>",
      body: "No fim do <body>",
      content: "Código HTML",
      contentPlaceholder: "<script>/* seu código */</script>",
      add: "Adicionar injeção",
      collapse: "Recolher",
      expand: "Editar código",
    },
  },
  customization: {
    tenants: "Clientes",
    title: "Personalização",
    desc: "Vale para todos os domínios do projeto, exceto os que têm configuração própria. As mudanças são publicadas na hora.",
  },
  seo: {
    title: "SEO e compartilhamento",
    desc: "Título, descrição e imagem que aparecem no Google e quando o link é compartilhado.",
    default: "Padrão do domínio",
    defaultDesc: "Usado em todas as páginas que não têm um padrão próprio.",
    paths: "Por página",
    pathsDesc: "Padrões mais específicos vencem. Use * no fim para prefixos (ex.: /blog/*).",
    addPath: "Adicionar página",
    pathPattern: "Padrão de caminho",
    pathPlaceholder: "/precos",
    pageTitle: "Título",
    description: "Descrição",
    image: "URL da imagem",
    imageHint: "Recomendado: 1200 × 630 px.",
    robots: "Robots",
    robotsHint: "Ex.: noindex, nofollow (deixe vazio para o padrão).",
    jsonLd: "JSON-LD",
    jsonLdHint: "Dados estruturados (opcional).",
    preview: "Pré-visualização do card social",
    saved: "SEO salvo",
    deleted: "Padrão removido",
    removeTitle: "Remover o SEO de {path}?",
    noPaths: "Nenhum padrão por página.",
    chars: "{n}/{max}",
  },
  // TailorKit: textos em features/tailorkit/strings.ts
  apiKeys: {
    title: "Chaves de API",
    subtitle: "Use a API para criar e gerenciar domínios direto do seu app.",
    docs: "Ver documentação",
    new: "Nova chave",
    emptyTitle: "Nenhuma chave ainda",
    emptyDesc: "Crie uma chave para integrar seu app (Bubble, n8n, back-end próprio) com a Tenanci.",
    col: {
      name: "Nome",
      key: "Chave",
      project: "Projeto",
      scopes: "Permissões",
      lastUsed: "Último uso",
      created: "Criada em",
    },
    allProjects: "Todos os projetos",
    revoke: "Revogar",
    revokeTitle: "Revogar a chave {name}?",
    revokeDesc: "Integrações que usam esta chave param de funcionar imediatamente.",
    revoked: "Chave revogada.",
    createTitle: "Nova chave de API",
    name: "Nome",
    namePlaceholder: "Ex.: Integração Bubble (produção)",
    project: "Restringir a um projeto",
    projectHint: "Chaves restritas só enxergam um projeto. Recomendado.",
    scopes: "Permissões",
    scopeLabels: {
      "domains:read": "Ler domínios",
      "domains:write": "Gerenciar domínios",
      "projects:read": "Ler projetos",
      "projects:write": "Gerenciar projetos",
    },
    scopesRequired: "Escolha ao menos uma permissão.",
    create: "Criar chave",
    secretTitle: "Copie sua chave agora",
    secretDesc: "Por segurança, esta é a única vez que mostramos a chave completa. Guarde-a em um lugar seguro.",
    secretDone: "Já copiei, fechar",
    rotate: "Rotacionar",
    rotateTitle: "Rotacionar a chave {name}?",
    rotateDesc: "Criamos uma chave nova com as mesmas permissões. A atual continua valendo pelo tempo escolhido, para você trocar nos sistemas sem parar.",
    grace: "A chave atual continua valendo por",
    graceOptions: { "0": "Para na hora", "1": "1 hora", "24": "24 horas", "168": "7 dias" },
    rotated: "Chave nova criada.",
    expires: "vale até {date}",
  },
  account: {
    title: "Minha conta",
    profile: "Perfil",
    name: "Nome",
    profileSaved: "Perfil atualizado",
    email: "E-mail",
    verified: "verificado",
    notVerified: "não verificado",
    changeEmail: "Alterar e-mail",
    newEmail: "Novo e-mail",
    changeEmailSent: "Enviamos um link de confirmação para o novo e-mail.",
    password: "Senha",
    currentPassword: "Senha atual",
    newPassword: "Nova senha",
    changePassword: "Alterar senha",
    passwordChanged: "Senha alterada.",
    revokeOthers: "Encerrar as outras sessões abertas",
    preferences: "Preferências",
    session: "Sessão",
    signOut: "Sair da conta",
    signOutDesc: "Encerra a sessão neste navegador.",
  },
  organization: {
    title: "Organização",
    subtitle: "Dados da sua empresa na Tenanci.",
    name: "Nome da organização",
    profile: "Perfil",
    referral: "Como nos encontrou",
    saved: "Organização atualizada",
    notSaved: "Não foi possível salvar agora (recurso ainda não disponível no servidor).",
    members: "Membros e convites",
    membersSoon: "Em breve você poderá convidar pessoas do seu time, com papéis de owner, admin ou membro.",
    tabs: { general: "Geral", team: "Equipe", webhooks: "Webhooks", activity: "Atividade" },
    notifyTitle: "Avisos por e-mail",
    notifyDomainStatus: "Avisar owners e admins quando um domínio entrar no ar, der erro ou for suspenso",
    notifySaved: "Preferência salva",
    emailLocale: "Idioma dos e-mails",
    emailLocaleHint: "Avisos de domínio, convites e o relatório mensal para os seus clientes.",
    suspendedBanner: "Esta organização está suspensa e os domínios estão fora do ar. Fale com support@tenanci.com.",
    impersonatingBanner: "Você está vendo a organização {org} como Equipe Tenanci. Tudo o que fizer fica registrado na atividade dela.",
    impersonatingExit: "Voltar para a minha organização",
    switchOrg: "Trocar de organização",
    team: {
      title: "Equipe",
      desc: "Pessoas com acesso a esta organização. Owners fazem tudo; admins gerenciam projetos, domínios e a equipe (menos owners); membros usam o painel.",
      you: "você",
      since: "desde {date}",
      role: "Papel",
      remove: "Remover",
      leave: "Sair da organização",
      removeTitle: "Remover {name}?",
      removeDesc: "A pessoa perde o acesso a esta organização na hora.",
      leaveTitle: "Sair de {org}?",
      leaveDesc: "Você perde o acesso a esta organização. Para voltar, alguém precisa convidar você de novo.",
      removed: "Pessoa removida",
      roleChanged: "Papel alterado",
      inviteTitle: "Convidar pessoa",
      inviteDesc: "Mandamos um link por e-mail, válido por 7 dias. A pessoa entra (ou cria a conta) com esse e-mail.",
      email: "E-mail",
      invite: "Convidar",
      invited: "Convite enviado para {email}",
      invitedNoEmail: "Convite criado. O e-mail não pôde ser enviado: copie o link e mande para a pessoa.",
      inviteLink: "Link do convite",
      pending: "Convites pendentes",
      expires: "vale até {date}",
      revoke: "Cancelar convite",
      revoked: "Convite cancelado",
      noPending: "Nenhum convite pendente.",
    },
    webhooks: {
      title: "Webhooks",
      desc: "Avise os seus sistemas quando algo acontecer na Tenanci (ex.: um domínio entrou no ar). Enviamos um POST JSON assinado para a sua URL.",
      empty: "Nenhum webhook ainda.",
      add: "Novo webhook",
      url: "URL (https)",
      description: "Descrição (opcional)",
      events: "Eventos",
      /** Chave = evento com "_" no lugar do "." (o "." separa níveis nas chaves de tradução). */
      eventNames: {
        domain_created: "Domínio adicionado",
        domain_status_changed: "Domínio mudou de status",
        domain_deleted: "Domínio removido",
        tailorkit_published: "TailorKit publicado",
      },
      create: "Criar webhook",
      created: "Webhook criado",
      secretTitle: "Segredo da assinatura",
      secretDesc: "Guarde agora: ele não aparece de novo. Use para conferir o header Tenanci-Signature (HMAC-SHA256 de \"<t>.<corpo>\").",
      enabled: "Ativo",
      test: "Enviar teste",
      tested: "Teste enviado. Veja o resultado nas entregas em alguns segundos.",
      rotate: "Gerar novo segredo",
      rotateTitle: "Gerar um novo segredo?",
      rotateDesc: "O segredo atual para de valer na hora. Atualize o seu sistema com o novo.",
      remove: "Remover",
      removeTitle: "Remover este webhook?",
      removed: "Webhook removido",
      deliveries: "Entregas",
      noDeliveries: "Nenhuma entrega ainda.",
      status: { pending: "Pendente", success: "Entregue", failed: "Falhou" },
      attempts: "{n} tentativa(s)",
      redeliver: "Reenviar",
      redelivered: "Reenviado",
      docs: "Formato e verificação da assinatura",
    },
    activity: {
      title: "Atividade",
      desc: "Quem fez o quê nesta organização (painel, API e Equipe Tenanci).",
      empty: "Nada registrado ainda.",
      more: "Carregar mais",
      filter: "Filtrar por ação",
      all: "Todas",
      groups: { domain: "Domínios", project: "Projetos", member: "Equipe", api_key: "Chaves de API", webhook: "Webhooks", billing: "Assinatura", tailorkit: "TailorKit", admin: "Administração" },
      adminBadge: "Equipe Tenanci",
    },
    yourRole: "Seu papel: {role}",
    roles: {
      owner: "Proprietário",
      admin: "Administrador",
      member: "Membro",
    },
    orgId: "ID da organização",
  },
  invite: {
    title: "Convite para {org}",
    desc: "{by} convidou você ({email}) para entrar como {role}.",
    descNoBy: "Você ({email}) foi convidado para entrar como {role}.",
    accept: "Aceitar convite",
    accepted: "Bem-vindo à {org}!",
    login: "Entrar para aceitar",
    signup: "Criar conta com {email}",
    invalid: "Este convite não existe, já foi usado ou venceu. Peça um novo para quem convidou você.",
    wrongEmail: "Você entrou com outro e-mail. Saia e entre com {email} para aceitar.",
  },
  blocked: {
    title: "Caminhos bloqueados",
    descProject: "Endereços que o edge recusa (erro 403) em todos os domínios do projeto, antes de chegar à origem. Ex.: /admin, /wp-login.php.",
    descDomain: "Só neste domínio (somam aos do projeto).",
    hint: "Bloqueia o caminho e tudo que começa com ele: /admin também bloqueia /admin/usuarios e /administrador.",
    add: "Adicionar",
    placeholder: "/admin",
    empty: "Nenhum caminho bloqueado.",
    fromProject: "Do projeto: {paths}",
    saved: "Caminhos bloqueados salvos",
    invalid: "Use um caminho que comece com / (e não só /).",
  },
  bug: {
    title: "Reportar um problema",
    desc: "Vamos abrir seu app de e-mail com os detalhes já preenchidos para support@tenanci.com.",
    what: "O que aconteceu?",
    whatPlaceholder: "Descreva o problema e os passos para reproduzir.",
    expected: "O que você esperava que acontecesse?",
    open: "Abrir e-mail",
    subject: "[Painel] Problema: {summary}",
    /** Corpo do e-mail de "Reportar problema" (BugReportDialog). */
    mail: {
      what: "O que aconteceu:",
      expected: "O que eu esperava:",
      context: "— Contexto (preenchido automaticamente) —",
      page: "Página: {value}",
      org: "Organização: {value}",
      browser: "Navegador: {value}",
      date: "Data: {value}",
    },
  },
  notFound: {
    title: "Página não encontrada",
    desc: "O endereço pode estar errado ou a página foi removida.",
    home: "Ir para o início",
  },
};
